import React from 'react';
import { MessageSquare, Hammer, Smile } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: MessageSquare,
    title: '1. Free Consultation',
    description: 'We visit your property to assess your needs, measure your driveway, and provide a detailed, no-obligation quote tailored to your home.'
  }, {
    icon: Hammer,
    title: '2. Professional Installation',
    description: 'Our expert team installs the heating elements and sensors with precision, coordinating with paving contractors for a seamless finish.'
  }, {
    icon: Smile,
    title: '3. Enjoy Winter',
    description: 'Your system runs automatically. Sit back with a warm coffee and watch the snow melt away while your neighbors are out shovelling.'
  }];
  return <section id="how-it-works" className="py-16 bg-slate-50 md:py-24 relative" data-id="element-229">
      <div className="container mx-auto px-4 md:px-6" data-id="element-230">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-231">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-232">
            Simple Process, Lasting Results
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-233">
            We make upgrading your home easy. From our first conversation to the
            first snowfall, we handle every detail.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 relative" data-id="element-234">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10" data-id="element-235">
            <div className="absolute inset-0 bg-primary/30 w-full h-full origin-left scale-x-0 animate-[grow_2s_ease-out_forwards]" data-id="element-236"></div>
          </div>

          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-237">
              <div className="w-24 h-24 rounded-full bg-white border-4 border-primary/20 flex items-center justify-center mb-6 shadow-lg z-10 group-hover:scale-110 group-hover:border-primary transition-all duration-300" data-id="element-238">
                <step.icon className="h-10 w-10 text-primary group-hover:text-primary/80 transition-colors" data-id="element-239" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors" data-id="element-240">
                {step.title}
              </h3>
              <p className="text-slate-600 max-w-xs" data-id="element-241">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}